<template>
  <section class="form-sec">
    <div class="wrapper">
      <div class="form-grid">
        <slot></slot>
      </div>
    </div>
  </section>
</template>
